import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiUserPackageDetailGet } from '@/entities/user-packages/modules/api/userPackages';

export const useUserPackageDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiUserPackageDetailGet(id ?? ''),
    keywords: queryKeys.userPackages.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
